<template>
  <b-button variant="primary" @click="exportData" :disabled="!items.length">
    <i class="text-white fas fa-file-excel "></i> Exportar Excel
  </b-button>
</template>

<script>
import { generateLiquidationExcel } from "@/utils/generateLiquidationExcel"; 
import { BButton } from 'bootstrap-vue';

export default {
  name: "ExcelButton",
  components: {
    BButton
  },
  props: {
    items: Array,
    details: Array,
    totals: Object,
    selectedDate: String
  },
  methods: {
    async exportData() {
      try {
        await generateLiquidationExcel({
          selectedDate: this.selectedDate,
          items: this.items,
          details: this.details,
          totals: this.totals
        });
        this.$toast.success("Excel exportado com sucesso!");
      } catch (error) {
        console.error(error);
        this.$toast.error("Erro ao gerar o Excel.");
      }
    }
  }
};
</script>